
import Vue from "vue";
import Api from "@/services/Api";
import { AxiosResponse } from "axios";
import { Overlay } from "@/lib/Overlay";
import { Alert } from "@/lib/Alert";
import moment from "moment";
import { Snackbar } from "@/lib/Snackbar";
import { PreCadastro } from "@/models/PreCadastro";
import VueMask from "v-mask";
import Swal from "sweetalert2";
import VueRecaptcha from "vue-recaptcha";

Vue.use(VueMask);
export default Vue.extend({
  name: "Pre-Cadastro",

  data() {
    return {
      checkbox: false,
      dialogAbrirContaConsultor: true,
      valid: true,
      loadingData: true,
      formAberturaConta: {} as PreCadastro,
      lang: navigator.language,
      errors: [],
      btnLoading: false,
      moment: moment,
      relacao: ["Sou o fundador", "Diretor", "Funcionário", "Outro"],
      portes: [
        "Microempreendedor Individual (MEI)",
        "Microempresa (ME)",
        "Empresa de Pequeno Porte (EPP)",
        "Empresa de Médio Porte",
        "Grande Empresa",
      ],
      segmentos: [
        "Acessórios automotivos",
        "Agência",
        "Agropecuária",
        "Alimentos",
        "Associação/Doação",
        "Brinquedos",
        "Cama, mesa e banho",
        "Consultoria/Advocacia",
        "Contabilidade",
        "Decoração",
        "Editoras e Gráficas",
        "Educação",
        "Energia solar",
        "Entretenimento",
        "Equipamentos",
        "Esportes",
        "Estética",
        "Fitness",
        "Funerária",
        "Games",
        "Indústria",
        "Joias e Relógios",
        "Moda",
        "Móveis",
        "Odontologia",
        "ONG e Oscip",
        "Outros",
        "Perfumaria e Cosméticos",
        "Petshop",
        "SaaS",
        "Saúde e convênios",
        "Seguradora",
        "Serviços",
        "Sexshop",
        "Tecnologia",
        "Telecom e Provedores",
        "Varejo",
      ],
      interesses: ["API PIX", "Cobranças", "Cripto", "Câmbio"],
      isMobile: false,
      emailRules: [
        (v: any) => !!v || "Informe seu e-mail",
        (v: any) => /.+@.+\..+/.test(v) || "Informe um e-mail válido",
      ],
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
    };
  },
  components: {
    "vue-recaptcha": VueRecaptcha,
  },

  methods: {
    onSubmitAbrirContaConsultor(token: string): void {
      this.errors = [];
      this.btnLoading = true;
      Overlay.show();
      Api.post("/v2/client/preregistro", this.formAberturaConta, {
        headers: {
          recaptcha: token,
        },
      })
        .then((response) => {
          window.location.replace(
            "https://ezzepay.com.br/pay/abrir-conta-finalizado/"
          );
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          if (status === 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
          this.resetRecaptcha();
        })
        .finally(() => {
          this.btnLoading = false;
          //  console.log("finalizou");

          Overlay.hide();
        });
    },
    onSubmit: function () {
      //this.windowOverlay = true;

      (this.$refs.invisibleRecaptcha as HTMLFormElement).execute();
    },
    onVerify: function (response: string) {
      this.onSubmitAbrirContaConsultor(response);
    },
    onExpired: function () {
      this.resetRecaptcha();
    },
    resetRecaptcha() {
      (this.$refs.invisibleRecaptcha as HTMLFormElement).reset(); // Direct call reset method
    },
  },
});
